import { render, staticRenderFns } from "./AccountTwoFaConfirmation.vue?vue&type=template&id=4c27e830&scoped=true"
import script from "./AccountTwoFaConfirmation.vue?vue&type=script&lang=js"
export * from "./AccountTwoFaConfirmation.vue?vue&type=script&lang=js"
import style0 from "./AccountTwoFaConfirmation.vue?vue&type=style&index=0&id=4c27e830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c27e830",
  null
  
)

export default component.exports